<template>
  <div class="popup" :class="{ isTempDB: isTempDB }" v-if="isPopup">
    <div class="camData" v-for="cam in chosenCam">
      <div class="camservices">
        <div>
          <h1>Services {{ howManyKeys(cam) }}</h1>
          <div class="entry">
            <label
              ><span v-if="liveStripchat.includes(cam.stripchat)">🟢</span>
              <a
                :href="`https://stripchat.com/${cam.stripchat}`"
                target="_blank"
                >Stripchat</a
              ></label
            >
            <input type="text" :value="cam.stripchat" />
          </div>
          <div class="entry" v-if="cam.chaturbate">
            <label>
              <a
                :href="`https://chaturbate.com/${cam.chaturbate}`"
                target="_blank"
                >Chaturbate</a
              ></label
            >
            <input type="text" :value="cam.chaturbate" />
          </div>
          <div class="entry" v-if="cam.bongacams">
            <label>
              <a
                :href="`https://bongacams.com/${cam.bongacams}`"
                target="_blank"
                >Bongacams</a
              ></label
            >
            <input type="text" :value="cam.bongacams" />
          </div>
          <div class="entry" v-if="cam.camsoda">
            <label
              ><a :href="`https://camsoda.com/${cam.camsoda}`" target="_blank"
                >Camsoda</a
              ></label
            >
            <input type="text" :value="cam.camsoda" />
          </div>
          <div class="entry" v-if="cam.cam4">
            <label
              ><a :href="`https://cam4.com/${cam.cam4}`" target="_blank"
                >Cam4</a
              ></label
            >
            <input type="text" :value="cam.cam4" />
          </div>
          <div class="entry" v-if="cam.cams">
            <label
              ><a :href="`https://cams.com/${cam.cams}`" target="_blank"
                >Cams.com</a
              ></label
            >
            <input type="text" :value="cam.cams" />
          </div>
          <div class="entry" v-if="cam.cammodels">
            <label
              ><a
                :href="`https://cammodels.com/cam/${cam.cammodels}`"
                target="_blank"
                >cammodels</a
              ></label
            >
            <input type="text" :value="cam.cammodels" />
          </div>
          <div class="entry" v-if="cam.livejasmin">
            <label
              ><a
                :href="`https://www.livejasmin.com/en/girls#!chat/${cam.livejasmin}`"
                target="_blank"
                >livejasmin</a
              ></label
            >
            <input type="text" :value="cam.livejasmin" />
          </div>
          <div class="entry" v-if="cam.streamate">
            <label
              ><a
                :href="`https://www.streamate.com/cam/${cam.streamate}`"
                target="_blank"
                >streamate</a
              ></label
            >
            <input type="text" :value="cam.flirt4free" />
          </div>
          <div class="entry" v-if="cam.flirt4free">
            <label
              ><a
                :href="`https://www.flirt4free.com/?model=${cam.flirt4free}`"
                target="_blank"
              >
                flirt4free</a
              ></label
            >
            <input type="text" :value="cam.flirt4free" />
          </div>
          <div class="entry" v-if="cam.imlive">
            <label
              ><a
                :href="` https://imlive.com/live-sex-chat/shy-girl/${cam.imlive}`"
                target="_blank"
                >imlive</a
              ></label
            >
            <input type="text" :value="cam.imlive" />
          </div>
          <div class="entry" v-if="cam.myfreecams">
            <label v-if="cam.myfreecams.includes('#')"
              ><a
                :href="`https://myfreecams.com/${cam.myfreecams}`"
                target="_blank"
                >myfreecams</a
              ></label
            >
            <label v-if="!cam.myfreecams.includes('#')"
              ><a
                :href="`https://myfreecams.com/#${cam.myfreecams}`"
                target="_blank"
                >myfreecams</a
              ></label
            >
            <input type="text" :value="cam.myfreecams" />
          </div>
          <div class="entry" v-if="cam.myfreecams">
            <label v-if="cam.myfreecams.includes('#')"
              ><a
                :href="`https://share.myfreecams.com/${cam.myfreecams.replace(
                  '#',
                  ''
                )}`"
                target="_blank"
                >share.myfreecams</a
              ></label
            >
            <label v-if="!cam.myfreecams.includes('#')"
              ><a
                :href="`https://share.myfreecams.com/${cam.myfreecams}`"
                target="_blank"
                >share.myfreecams</a
              ></label
            >
            <input type="text" :value="cam.myfreecams" />
          </div>
        </div>
        <div>
          <div class="entry small">
            <label>ID: <br />{{ cam.id }}</label>
          </div>
          <div class="entry small">
            <!-- <label> {{ cam.createdAt.seconds }}</label> -->
            <label> {{ parseDate(cam.createdAt.seconds) }} ago</label>
            <!-- <label> {{ cam.createdAt }}</label> -->
          </div>
        </div>
      </div>

      <div class="details">
        <h1>Details</h1>
        <div class="entry">
          <label> Name</label>
          <input type="text" :value="cam.name" />
        </div>

        <!-- <div class="entry" v-if="!cam.name">
          <label>New Name</label>
          <input type="text" v-model="newName" />
        </div> -->

        <div class="entry">
          <label> Age</label>
          <input type="text" :value="cam.age" disabled />
        </div>
        <div class="entry">
          <label> broadcast Gender</label>
          <input type="text" :value="cam.broadcastGender" disabled />
        </div>
        <div class="entry">
          <label> contest Gender</label>
          <input type="text" :value="cam.contestGender" disabled />
        </div>
      </div>

      <div class="socials">
        <h1>Socials</h1>
        <div class="entry" v-if="cam.twitter">
          <label
            v-if="
              cam.twitter.includes('twitter.com') &&
              !cam.twitter.includes('/status/')
            "
            ><a :href="`https://${cam.twitter}`" target="_blank"
              ><span
                v-if="
                  cam.twitter != 'twitter.com/intent/tweet' &&
                  cam.twitter != 'twitter.com/home'
                "
                >🔷</span
              >twitter</a
            >
          </label>

          <label
            v-if="
              cam.twitter.includes('twitter.com') &&
              cam.twitter.includes('/status/')
            "
            ><a
              :href="`https://${normalizeTwitterUrl(cam.twitter)}`"
              target="_blank"
              ><span v-if="cam.twitter">🔷</span>twitter</a
            >
          </label>

          <input type="text" :value="cam.twitter" />
        </div>
        <div class="entry" v-if="cam.instagram">
          <label v-if="!cam.instagram.includes('instagram.com')"
            ><a :href="`https://instagram.com/${cam.instagram}`" target="_blank"
              >🔺instagram</a
            ></label
          >
          <label v-if="cam.instagram.includes('instagram.com')"
            ><a :href="`https://${cam.instagram}`" target="_blank"
              >🔺instagram</a
            ></label
          >
          <input type="text" :value="cam.instagram" />
        </div>
        <div class="entry" v-if="cam.allmylinks">
          <label
            ><a :href="`${cam.allmylinks}`" target="_blank">
              🟡allmylinks</a
            ></label
          >
          <input type="text" :value="cam.allmylinks" />
        </div>
        <div class="entry" v-if="cam.snapchat">
          <label
            ><a :href="`https://${cam.snapchat}`" target="_blank">
              snapchat</a
            ></label
          >
          <input type="text" :value="cam.snapchat" />
        </div>
        <div class="entry" v-if="cam.facebook">
          <label
            ><a :href="`https://${cam.facebook}`" target="_blank">
              facebook</a
            ></label
          >
          <input type="text" :value="cam.facebook" />
        </div>
        <div class="entry" v-if="cam.xhamster">
          <label
            ><a :href="`https://${cam.xhamster}`" target="_blank">
              xhamster</a
            ></label
          >
          <input type="text" :value="cam.xhamster" />
        </div>
        <div class="entry" v-if="cam.fancentro">
          <label
            ><a :href="`https://${cam.fancentro}`" target="_blank">
              fancentro</a
            ></label
          >
          <input type="text" :value="cam.fancentro" />
        </div>
        <div class="entry" v-if="cam.xhamsterPornstar">
          <label
            ><a :href="`https://${cam.xhamsterPornstar}`" target="_blank">
              xhamsterPornstar</a
            ></label
          >
          <input type="text" :value="cam.xhamsterPornstar" />
        </div>
        <div class="entry" v-if="cam.myClub">
          <label
            ><a :href="`https://${cam.myClub}`" target="_blank">
              myClub</a
            ></label
          >
          <input type="text" :value="cam.myClub" />
        </div>
        <div class="entry" v-if="cam.manyvids">
          <label
            ><a
              v-if="!cam.manyvids.includes('/')"
              :href="`https://${cam.manyvids}.manyvids.com/`"
              target="_blank"
            >
              manyvids</a
            >
            <a
              v-if="cam.manyvids.includes('/')"
              :href="`https://www.manyvids.com/Profile/${cam.manyvids}/Store/Videos/`"
              target="_blank"
            >
              manyvids</a
            >
          </label>
          <input type="text" :value="cam.manyvids" />
        </div>

        <div class="entry" v-if="cam.onlyfans">
          <label
            ><a :href="`https://onlyfans.com/${cam.onlyfans}`" target="_blank">
              onlyfans</a
            ></label
          >
          <input type="text" :value="cam.onlyfans" />
        </div>

        <div class="entry additional" v-for="(camValue, camKey) in cam">
          <!-- <div v-if="camKey !== 'status'"> -->
          <div v-if="!standardFields.includes(camKey)">
            <label>
              <a :href="`${camValue}`" target="_blank"> {{ camKey }}</a>
            </label>
            <input type="text" :value="camValue" />
          </div>
        </div>
      </div>
      <twitter-box
        :camData="chosenCam"
        :camId="cam.id"
        :databaseType="databaseName"
        :isCamgirlPro="isCamgirlPro"
      ></twitter-box>
      <div class="statusContainer">
        <div
          class="camStatusBtn"
          @click="
            camDone(cam.id, 'done'), handleDoneToday('done'), (isPopup = false)
          "
          v-if="isPopup"
        >
          ✔️ done
        </div>

        <div
          class="camStatusBtn greyBtn"
          @click="
            camDone(cam.id, 'studio'),
              handleDoneToday('studio'),
              (isPopup = false)
          "
          v-if="isPopup"
        >
          studio
        </div>
        <div
          class="camStatusBtn greyBtn"
          @click="
            camDone(cam.id, 'not exist'),
              handleDoneToday('not exist'),
              (isPopup = false)
          "
          v-if="isPopup"
        >
          💀 not exist
        </div>
        <div
          class="camStatusBtn greyBtn"
          @click="
            camDone(cam.id, 'pending'),
              handleDoneToday('pending'),
              (isPopup = false)
          "
          v-if="isPopup"
        >
          ⌛ pending...
        </div>
        <div
          class="camStatusBtn greyBtn"
          @click="
            camDone(cam.id, 'male'), handleDoneToday('male'), (isPopup = false)
          "
          v-if="isPopup"
        >
          🍆male
        </div>
        <div
          class="camStatusBtn greyBtn"
          @click="
            camDone(cam.id, 'other'),
              handleDoneToday('other'),
              (isPopup = false)
          "
          v-if="isPopup"
        >
          other
        </div>
        <div
          class="camStatusBtn greyBtn magic"
          @click="pasteHtmlBio()"
          v-if="isPopup"
        >
          🔮 convert-bio
        </div>
      </div>
    </div>

    <button
      @click="
        getLiveStripchatWithTwitter(),
          clearCurrentId(),
          resetChosenCamData(),
          (isPopup = false)
      "
      class="closeBtn"
    >
      ×
    </button>
  </div>

  <div class="home" :class="{ isTempDB: isTempDB }">
    <!-- <textarea name="" id="mainTextarea"></textarea> -->
    <input
      type="text"
      class="search"
      placeholder="Enter nickname"
      v-model="search"
    />
    <button @click="pasteFromClipboard" class="addNew">+</button>
    <button @click="getDataStripchat(search), openPopup()" class="search-btn">
      <!-- <button @click="handleSearch('stripchat', search)" class="search-btn"> -->
      search
    </button>
    <!-- <button @click="getDataStripchat(search)" class="getData">getData</button> -->
    <button @click="getLiveStripchat" class="getData">
      🟢 get Live Stripchat
    </button>

    <!-- <button @click="getLiveStripchatTodo" class="getData">🟢 todo</button> -->
    <button @click="getLiveStripchatWithTwitter" class="getData">
      🟢 todo (Twitter)
    </button>
    <button
      @click="printLast200nicks"
      v-if="liveStripchat.length > 0 && false"
      class="getData"
    >
      print Last 200 nicks
    </button>
    <button
      @click="checkFirst500nicks(checkFrom, checkTo)"
      v-if="liveStripchat.length > 0"
      class="getData"
    >
      check {{ checkTo - checkFrom ? checkTo - checkFrom : "" }} nicks ({{
        checkFrom
      }}—{{ checkTo }})
    </button>
    <input
      type="text"
      class="getData"
      placeholder="from"
      v-model="checkFrom"
    />—
    <input type="text" class="getData" placeholder="to" v-model="checkTo" />
    {{ doneToday ? doneToday : "" }}<span v-if="doneTodaySummary">/</span
    >{{ doneTodaySummary ? doneTodaySummary : "👌" }}

    <div v-if="!isOnlyOnline">
      <div
        class="row"
        v-for="cam in cams"
        @click="
          getDataStripchat(getCamNick(cam.id)),
            openPopup(),
            getChosenCamData(chosenCam)
        "
        :key="cam.id"
      >
        <div class="status">{{ cam.status }}</div>
        <div class="online">
          <span v-if="liveStripchat.includes(cam.stripchat)">🟢</span>
          <span v-if="!liveStripchat.includes(cam.stripchat)">⚫</span>
        </div>
        <div class="camservice">
          {{ cam.stripchat }}
        </div>
        <div class="camservice">{{ cam.chaturbate }}</div>
        <div class="camservice">{{ cam.bongacams }}</div>
        <div class="id">{{ cam.id }}</div>
      </div>
    </div>
    <div v-if="isOnlyOnline">
      <div
        v-for="cam in cams"
        class="row"
        :class="{ hidden: !liveStripchat.includes(cam.stripchat) }"
        @click="
          getDataStripchat(getCamNick(cam.id)),
            getChosenCamData(chosenCam),
            openPopup()
        "
        :key="cam.id"
      >
        <div class="status">{{ cam.status }}</div>
        <div class="online">
          <span v-if="liveStripchat.includes(cam.stripchat)">🟢</span>
          <span v-if="!liveStripchat.includes(cam.stripchat)">⚫</span>
        </div>
        <div class="camservice">
          {{ cam.stripchat }}
        </div>
        <div class="camservice">{{ cam.chaturbate }}</div>
        <div class="camservice">{{ cam.bongacams }}</div>
        <div class="id">{{ cam.id }}</div>
      </div>
    </div>

    <!-- <div v-for="cam in cams">{{ cam.status }} :{{ cam.stripchat }}</div> -->
  </div>
  <div class="logout">
    <button @click="handleClickLogout" class="getData" v-if="user">
      🔓 Logout ({{ user.email }})
    </button>
    <button
      @click="handleClickChangeDatabase"
      class="getData"
      v-if="user && isTempDB"
    >
      🧱 change to PROD DB
    </button>
    <button
      @click="handleResetDoneToday"
      class="getData"
      v-if="user && doneToday"
    >
      🧽 Reset ({{ doneToday }}/{{ doneTodaySummary }}) counter
    </button>
    <button
      @click="handleClickChangeDatabase"
      class="getData"
      v-if="user && !isTempDB"
    >
      🧱 change to TEST DB
    </button>
  </div>
</template>

<script>
import { ref, onMounted } from "@vue/reactivity";
import { formatDistanceToNow, parse } from "date-fns";
import getCollection from "@/composables/getCollection";
import { db, serverTimestamp } from "../firebase/config";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";
import getUser from "../composables/getUser";
import { useRouter } from "vue-router";
import { computed, watchEffect } from "@vue/runtime-core";

import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import TwitterBox from "../components/TwitterBox.vue";

import uniqBy from "lodash/uniqBy";

export default {
  components: { TwitterBox },
  name: "Home",

  setup() {
    const databaseName = ref("cams"); // TEMP
    const isTempDB = ref(true); // TEMP
    // const databaseType = ref("non-TEMP"); // TEMP
    // const databaseName = ref("cams"); // PROD
    const { user } = getUser();
    const router = useRouter();

    const allNewUrls = ref(null);
    const splittedUrls = ref([]);
    const additionalSplittedUrls = ref([]);
    const search = ref([]);
    const liveStripchat = ref([]);
    const isPopup = ref(false);
    const clickedId = ref(null);
    const chosenCam = ref(null);
    const chosenCamData = ref(null);
    const camDataTemp1 = ref(null);
    const camDataTemp2 = ref(null);
    const currentCamId = ref(null);
    const addNewCamEl = ref("");
    const checkTo = ref();
    const checkFrom = ref();
    const isOnlyOnline = ref(false);
    const doneToday = ref("");
    const doneTodaySummary = ref("");
    const newName = ref("");
    const isTestingMode = ref(false);
    const allServices = ref([]);
    const standardFields = ref([]);
    const isCamgirlPro = ref(null);

    const allBasicFields = [
      "status",
      "id",
      "createdAt",
      "lastTweet",
      "name",
      "age",
      "broadcastGender",
      "contestGender",
      "twitter",
      "instagram",
      "snapchat",
      "facebook",
      "xhamster",
      "fancentro",
      "xhamsterPornstar",
      "myClub",
      "onlyfans",
      "manyvids",
      "flirt4free",
      "allmylinks",
    ];
    const allCamServices = [
      "chaturbate",
      "stripchat",
      "bongacams",
      "camsoda",
      "cam4",
      "cams",
      "streamate",
      "livejasmin",
      "myfreecams",
      "mfc",
      "imlive",
      "cherry",
      "cammodels",
      "tiktok",
      "instagram",
      "twitter",
    ];

    const allLinksServices = [
      "allmylinks",
      "magic",
      "linktr",
      "my",
      "friendsbio",
      "tapmybio",
      "bemyfan",
      "bybio",
      "beacons",
      "atom",
      "sexworker",
      "hubzter",
      "myslink",
      "solo",
      "konect",
      "divacontent",
      "mylinkdrop",
      "328",
      "myslink",
      "tapmybio",
      "friendsbio",
      "campsite",
      "instabio",
    ];
    const allOnlyfanstypeServices = ["onlyfans"];

    allServices.value = [
      ...allCamServices,
      // ...allLinksServices,
      ...allOnlyfanstypeServices,
    ];

    standardFields.value = [...allBasicFields, ...allCamServices];

    // TODO trzeba tez zrobic podmiane CAMS jesli robie zmiane buttonem nazwy bazy danych

    if (localStorage.getItem("CS-doneToday")) {
      doneToday.value = localStorage.getItem("CS-doneToday");
    }
    if (localStorage.getItem("CS-doneTodaySummary")) {
      doneTodaySummary.value = localStorage.getItem("CS-doneTodaySummary");
    }

    const { documents: cams } = getCollection(databaseName.value, "twitter");
    //  { documents: cams.value } = getCollection(databaseName.value, "twitter");
    // cams.value = getCollection(databaseName.value, "twitter")["documents"];

    //////////////////

    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    function generateRandom(maxLimit = 11) {
      let rand = Math.random() * maxLimit;
      console.log(rand);
      rand = Math.floor(rand); // 99
      return rand;
    }

    const pasteFromClipboard = async () => {
      try {
        const text = await navigator.clipboard.readText();

        allNewUrls.value = text.split("\r\n");
        allNewUrls.value.forEach(getDomain);

        splittedUrls.value.forEach(async (el) => {
          for (const [key, value] of Object.entries(el)) {
            // console.log(el);
            // console.log(`${key}: ${value}`);

            if (key == "stripchat" && value) {
              // sprawdz czy ma Twittera na stripie, jesli ma to idziemy dalej i sprawdzamy czy mam to juz w bazie
              // sprawdz czy istnieje juz taki nick w bazie, jesli nie to dodaj, jesli istnieje to nic nie rob
              let number = await handleSearch(key, value); // jezeli to jest = 0 to dopiero zrob SubmitData, w innym przypadku nie rob nic
              if (number == 0) {
                console.log("———————————");
                console.log("TEMP camData:", el);
                console.log("⌛ waiting for Stripchat data");

                let data = await getDataStripchat(value);
                // console.log(data);

                if (data) {
                  let elNew = { ...data, ...el };
                  console.log(elNew);
                  handleSubmitData(elNew);
                } else {
                  // console.log("———————————");
                  allNewUrls.value = [];
                  splittedUrls.value = [];

                  return;
                }
              } else {
                //  pobierz nowe dane ze Stripchata i porownaj obiekty, jesli sie czyms roznia to dodaj dodatkowe pola do bazy
                // camDataTemp1.value = data;
                console.log(camDataTemp1.value); // obiekt pobrany z serwera
                camDataTemp2.value = await getDataStripchat(value);
                console.log(camDataTemp2.value); // obiekt pobrany ze stripchata
                // camDataTemp2.value = {};
                let additionalCamData = diff(
                  camDataTemp1.value,
                  camDataTemp2.value
                );
                console.log(additionalCamData);

                if (Object.keys(additionalCamData).length > 0) {
                  for (const [key, value] of Object.entries(
                    additionalCamData
                  )) {
                    if (value === null) {
                      delete additionalCamData[`${key}`];
                    }
                  }
                } else {
                  console.log(
                    `🛑 There is NO differences between old/new data \n\n`
                  );
                }

                console.log(additionalCamData);
                /// update danych na serwerze (currentCamId)
                // NOTE zawsze sie na firebasie zapisza nowe informacje
                //
                if (additionalCamData) {
                  updateCamInfo(currentCamId.value, additionalCamData);
                }
                camDataTemp1.value = {};
                camDataTemp2.value = {};
                currentCamId.value = "";
              }
            }
            if (key == "bongacams" && value) {
              console.log("sprawdzamy bongacams konto");
              return;
            } else if (key == "chaturbate" && value) {
              console.log("sprawdzamy chaturbate konto");
              return;
            }
          }
        });

        allNewUrls.value = [];
        splittedUrls.value = [];
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    };

    const handleSearch = async (service, search) => {
      const q = query(
        collection(db, databaseName.value),
        where(service, "==", search)
      );

      const querySnapshot = await getDocs(q);
      let counter = 0;

      querySnapshot.forEach((doc) => {
        counter++;
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, " => ", doc.data());
        camDataTemp1.value = doc.data();
        currentCamId.value = doc.id;
      });
      console.log("Counter: ", counter);

      return counter;
    };

    //////////////////////////////// COMPARE OBJECTS
    /*!
     * Find the differences between two objects and push to a new object
     * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
     * @param  {Object} obj1 The original object
     * @param  {Object} obj2 The object to compare against it
     * @return {Object}      An object of differences between the two
     */
    const diff = function (obj1, obj2) {
      console.log(obj1);
      console.log(obj2);

      // Make sure an object to compare is provided
      if (!obj2 || Object.prototype.toString.call(obj2) !== "[object Object]") {
        return obj1;
      }

      //
      // Variables
      //

      let diffs = {};
      let key;

      //
      // Methods
      //

      /**
       * Check if two arrays are equal
       * @param  {Array}   arr1 The first array
       * @param  {Array}   arr2 The second array
       * @return {Boolean}      If true, both arrays are equal
       */
      const arraysMatch = function (arr1, arr2) {
        // Check if the arrays are the same length
        if (arr1.length !== arr2.length) return false;

        // Check if all items exist and are in the same order
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i] !== arr2[i]) return false;
        }

        // Otherwise, return true
        return true;
      };

      /**
       * Compare two items and push non-matches to object
       * @param  {*}      item1 The first item
       * @param  {*}      item2 The second item
       * @param  {String} key   The key in our object
       */
      const compare = function (item1, item2, key) {
        // Get the object type
        let type1 = Object.prototype.toString.call(item1);
        let type2 = Object.prototype.toString.call(item2);

        // If type2 is undefined it has been removed
        if (type2 === "[object Undefined]") {
          diffs[key] = null;
          return;
        }

        // If items are different types
        if (type1 !== type2) {
          diffs[key] = item2;
          return;
        }

        // If an object, compare recursively
        if (type1 === "[object Object]") {
          let objDiff = diff(item1, item2);
          if (Object.keys(objDiff).length > 0) {
            diffs[key] = objDiff;
          }
          return;
        }

        // If an array, compare
        if (type1 === "[object Array]") {
          if (!arraysMatch(item1, item2)) {
            diffs[key] = item2;
          }
          return;
        }

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (type1 === "[object Function]") {
          if (item1.toString() !== item2.toString()) {
            diffs[key] = item2;
          }
        } else {
          if (item1 !== item2) {
            diffs[key] = item2;
          }
        }
      };

      //
      // Compare our objects
      //

      // Loop through the first object
      for (key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          compare(obj1[key], obj2[key], key);
        }
      }

      // Loop through the second object and find missing items
      for (key in obj2) {
        if (obj2.hasOwnProperty(key)) {
          if (!obj1[key] && obj1[key] !== obj2[key]) {
            diffs[key] = obj2[key];
          }
        }
      }

      // Return the object of differences
      return diffs;
    };
    ////////////////////////////////END  COMPARE OBJECTS

    class UrlSplitted {
      constructor(service, nickname, timestamp) {
        // this.xxx = service;
        // this.nickname = nickname;
        if (service == "stripchat") {
          this.stripchat = nickname;
        }
        if (service == "chaturbate") {
          this.chaturbate = nickname;
        }
        if (service == "bongacams") {
          this.bongacams = nickname;
        }
        this.status = "todo";
      }
    }

    const clearDomain = (url) => {
      if (url.startsWith("http") || url.startsWith("www")) {
        let domain = new URL(url);
        const pathname = domain.pathname;
        const domainName = domain.hostname;
        return `${domain.hostname}${domain.pathname}`;
      } else {
        // console.log("URL nie zaczyna sie od http OR www");
        // console.log(url);
        let urlTemp = "https://www." + url;
        // console.log(urlTemp);
        let domain = new URL(urlTemp);
        // let domain = new URL(url);
        const pathname = domain.pathname;
        const domainName = domain.hostname;
        return `${domain.hostname}${domain.pathname}`;
      }
    };

    const getDomain = (url) => {
      let domain = new URL(url);

      const pathname = domain.pathname;
      let domainName = domain.hostname;
      let nickname = pathname.replace("/", "");

      if (domainName.includes("stripchat")) {
        domainName = "stripchat";
      }
      if (domainName.includes("bongacams")) {
        domainName = "bongacams";
      }
      if (domainName.includes("chaturbate")) {
        domainName = "chaturbate";
      }

      const UrlSplittedItem = new UrlSplitted(domainName, nickname);
      splittedUrls.value.push(UrlSplittedItem);
    };

    class AdditionalUrlSplitted {
      constructor(service, nickname) {
        if (allServices.value.includes(service)) {
          this[service] = nickname;
        } else {
          // this.www = nickname;
          this[service] = nickname;
        }

        this[service] = nickname;
      }
    }

    const testArrIsAllDigits = (arr) => {
      console.log(arr);
      let isTrue = arr.some((el) => {
        return isNaN(Number(el));
      });
      return !isTrue;
    };

    // const testArr2 = ["20", "cc", "15", "19"];
    // let test123 = testArrIsAllDigits(testArr2);
    // console.log(test123);

    function stringContainsNumber(_string) {
      return /\d/.test(_string);
    }

    const removeSlashFromString = (word) => {
      if (word.endsWith("/")) {
        word = word.slice(0, -1);
        console.log("🔥", word);
      }
      console.log(word);
      return word;
    };

    const makeArrOfNewDomains = (url) => {
      console.log(url);
      if (url.includes("////")) {
        url = url.replaceAll("////", "//");
      }
      let domain = new URL(url);
      console.log(domain);
      console.log(domain.search);

      const pathname = domain.pathname;
      let domainName = domain.hostname;
      let href = domain.href;
      let search = domain.search;
      let nickname = pathname.replace("/", "");
      console.log("nickname:", nickname);

      //NOTE myfreecams.com/#candytreo
      if (url.includes("myfreecams.com/#")) {
        nickname = domain.hash;
      }
      if (url.includes("share.myfreecams.com")) {
        let nicknameTemp = domain.pathname.split("/");
        console.log(nicknameTemp);
        nickname = nicknameTemp[1];
        nickname = removeSlashFromString(nickname);
        console.log(nickname);
      }
      //  https://profiles.myfreecams.com/MeaowMela
      if (url.includes("profiles.myfreecams.com/")) {
        nickname = domain.pathname.replace("/", "");
      }

      // NOTE https://cammodels.com/cam/LadyShibariOrchid
      // meganblair18.cammodels.com/?langchoice=es
      if (url.includes(".cammodels.com")) {
        let nicknameArr = url.split(".");
        nickname = nicknameArr[0];
        nickname = nickname.replaceAll("https://", "");
        domainName = "cammodels";
      }

      // https://www.livejasmin.com/pl/chat-html5/MelodyHolmes?refererid=p_MelodyHorn
      // https://www.livejasmin.com/en/girls/#!chat/AshleyMoreno
      if (url.includes("livejasmin.com") && url.includes("#")) {
        console.log(domain.hash);
        let nicknameTemp = domain.hash.split("/");
        console.log(nicknameTemp);
        nickname = nicknameTemp[nicknameTemp.length - 1];
        nickname = removeSlashFromString(nickname);
        console.log(nickname);
      }
      if (url.includes("livejasmin.com") && !url.includes("#")) {
        let tempUrlArr = url.split("?");
        let tempUrl = tempUrlArr[0];

        tempUrlArr = tempUrl.split("/");
        tempUrl = tempUrlArr[tempUrlArr.length - 1];
        nickname = tempUrl;

        nickname = removeSlashFromString(nickname);
        console.log(nickname);
      }

      let domainNameArr = domainName.replace("www.", "").split(".");
      console.log(domainNameArr);

      if (domainNameArr.length == 2) {
        if (allServices.value.includes(domainNameArr[0])) {
          domainName = domainNameArr[0];
          console.log(domainName);
        } else {
          console.log("🟥 www ");
          nickname = href;
          console.log(nickname);
          domainName = domainNameArr[0];
          let domainExtention = domainNameArr[1];
          console.log(domainName, domainExtention);
          if (
            domainExtention.length > 4 ||
            stringContainsNumber(domainExtention)
          ) {
            return new AdditionalUrlSplitted("remove", null);
          }
        }
      }

      if (domainNameArr.length == 3) {
        if (allServices.value.includes(domainNameArr[1])) {
          domainName = domainNameArr[1];
        } else {
          console.log("🟥 www ");
          nickname = href;
          domainName = domainNameArr[1];
          let domainExtention = domainNameArr[2];
          console.log(domainName, domainExtention);
          if (
            domainExtention.length > 4 ||
            stringContainsNumber(domainExtention)
          ) {
            return new AdditionalUrlSplitted("remove", null);
          }
        }
      }

      if (domainName == "mfc") {
        domainName = "myfreecams";
      }

      if (nickname.includes("cam/")) {
        nickname = nickname.replace("cam/", "");
        nickname = removeSlashFromString(nickname);
      }

      // NOTEhttps://imlive.com/live-sex-chat/shy-girl/honeysallymoore/?gid=1
      console.log(url);
      if (url.includes("imlive")) {
        let nickname = domain.pathname.split("/");
        nickname = nickname.filter(function (el) {
          return el != "";
        });
        nickname = Object.keys(nickname).map((key) => nickname[key]);
        nickname = nickname[nickname.length - 1];
        nickname = removeSlashFromString(nickname);
        console.log(nickname);
        console.log(domainName);
        return new AdditionalUrlSplitted(domainName, nickname);
      }

      // NOTE https://www.manyvids.com/Profile/1003738586/jane_goddess/Store/Videos/

      if (url.includes("manyvids") && !url.includes("live.")) {
        // console.log(url);

        url = url
          .replaceAll(
            /(?:\/about|\/services|\/pics|\/store\/videos|\/services|\/storevideos)/gi,
            ""
          )
          .replaceAll("//", "/");

        // console.log(url);
        let nickname = url.split("/");
        nickname = nickname.filter(function (el) {
          return el != "";
        });

        let nameManyvids;
        let idManyvids;
        let testArr = [];

        // console.log(nickname[nickname.length - 1]);
        testArr.push(nickname[nickname.length - 1]);
        // console.log(testArrIsAllDigits(testArr));

        if (testArrIsAllDigits(testArr)) {
          idManyvids = nickname[nickname.length - 1];
          nameManyvids = nickname[nickname.length - 2];
        } else {
          nameManyvids = nickname[nickname.length - 1];
          idManyvids = nickname[nickname.length - 2];
        }

        // console.log(nameManyvids);
        // console.log(idManyvids);
        nickname = idManyvids + "/" + nameManyvids;
        // NOTE https://www.manyvids.com/Profile/1003738586/Jane_Goddess/Store/Videos

        if (nickname.includes("https")) {
          nickname = nickname
            .replaceAll("https:/", "")
            .replaceAll(".manyvids.com", "");
        }

        console.log(nickname);
        console.log(domainName);
        return new AdditionalUrlSplitted(domainName, nickname);
      }
      // https://live.manyvids.com/Karlee_Grey
      if (url.includes("live.manyvids.com/")) {
        console.log(url);
        domain = url.replaceAll("////", "//");
        console.log(domain);
        // console.log(domain.pathname);
        let nicknameArr = domain.split("/");
        // nickname = url.pathname.replace("/", "");
        nickname = nicknameArr[nicknameArr.length - 1];
        console.log(domain);
        console.log(nickname);
        console.log(domainName);
        domainName = "manyvids";
        return new AdditionalUrlSplitted(domainName, nickname);
      }

      //NOTE chaturbate.com/in/?tour=7Bge&campaign=SyH6n&room=amarantabeckam
      if (url.includes("chaturbate.com/in/")) {
        console.log(search);
        console.log(domain.search);
        // nickname = domain.search.replaceAll("?model=", "");
        let nicknameArr = domain.search.split("&");
        console.log(nicknameArr);

        nicknameArr = nicknameArr.filter((el) => {
          if (el.includes("room=")) {
            return el;
          }
        });

        nickname = nicknameArr[0].replaceAll("room=", "");
        nickname = removeSlashFromString(nickname);
        console.log(nickname);
        console.log(url);
      }

      //NOTE https://www.flirt4free.com/?model=indy-maze
      // https://www.flirt4free.com/?model=vergill-hell&utm_source=auto-tweet&utm_medium=social&utm_campaign=model_login&utm_content=vergill-hell
      // https://www.flirt4free.com/?model=anna-lesko&utm_source=auto-tweet&utm_medium=social&utm_campaign=model_login&utm_content=anna-lesko
      // https://www.flirt4free.com/?model=gina-max23
      // https://www.flirt4free.com/models/bios/mia-fletcher/about.php?tracking_code=MIA_FLETCHER&utm_source=auto-tweet&utm_medium=social&utm_campaign=model_login&utm_content=mia-fletcher
      // https://www.flirt4free.com/videos/trans/webcam/23884378-salo-hot-private-webcam-show.php?utm_source=auto-tweet&utm_medium=social&utm_campaign=new_vod&utm_content=salo-hot&tracking_code=SALO_HOT
      if (url.includes("flirt4free")) {
        console.log(search);
        console.log(domain.search);

        let domainSearchArr = domain.search.split("&");

        domainSearchArr = domainSearchArr.filter((el) => {
          return el.includes("utm_content=") || el.includes("model=");
        });

        nickname = domainSearchArr[0]
          .replace("utm_content=", "")
          .replace("?model=", "");

        console.log(domainSearchArr);
        console.log(nickname);
        nickname = removeSlashFromString(nickname);

        if (nickname.includes("https://www.flirt4free.com/?model=")) {
          nickname = nickname.replace("https://www.flirt4free.com/?model=", "");
        }
        console.log(nickname);
        console.log(url);
      }

      if (allServices.value.includes(domainName) && !nickname) {
        console.log("There is NO nickname in [allServices] domain");
        return new AdditionalUrlSplitted("remove", null);
      }

      if (domainNameArr.length > 3) {
        console.log("🍎", domainNameArr.length);
        console.log("🍎", domainName);
      }

      // TODO spradzenie czy kazdy element z domainNameArr jest liczba
      // TODO sprawdzic czy jakikolwiek element z domainNameArr nie jesli liczba
      if (testArrIsAllDigits(domainNameArr)) {
        return new AdditionalUrlSplitted("remove", null);
      } else if (domainName == "stripchat" && !nickname) {
        return new AdditionalUrlSplitted("remove", null);
      } else {
        nickname = removeSlashFromString(nickname);
        return new AdditionalUrlSplitted(domainName, nickname);
      }
    };

    const addAdditionalUnique = (arr) => {
      console.log("🆔", currentCamId.value);

      additionalSplittedUrls.value.push(
        ...arr.map((el) => makeArrOfNewDomains(el))
      );

      console.log(additionalSplittedUrls.value);
      // TODO make array elements unique, nie dziala w przypadku tego https://twitter.com/KrissForau gdzie sa dwa konta OF z roznymi nickami
      let unique = uniqBy(
        additionalSplittedUrls.value,
        (el) => Object.keys(el)[0] + Object.values(el)[0]
      );

      console.log(unique);
      return unique;
    };

    // let testData = [
    //   "https://chaturbate.com/b/miss_flora/",
    //   "https://www.instagram.com/flora_modelocolombiana",
    //   "https://www.tiktok.com/@florajust",
    //   "https://es.stripchat.com/miss--flora",
    //   "https://cam4.es/miss_flora_",
    //   "https://es.chaturbate.com/miss_flora/",
    // ];

    ////////////////////////
    const handleSubmitData = async (data) => {
      const colRef = collection(db, databaseName.value);
      const objData = JSON.parse(JSON.stringify(data));
      await addDoc(colRef, { ...objData, createdAt: serverTimestamp() });
      console.log("✅ DONE handleSubmitData ");
    };

    const stripchatCamData = {
      name: null,
      contestGender: null,
      broadcastGender: null,
      age: null,
    };

    const clearCurrentId = () => {
      currentCamId.value = "";
      console.log("currentCamId — CLEAR");
    };

    const getDataStripchat = async (nickname) => {
      if (!nickname) return;

      const res = await fetch(
        `https://stripchat.com/api/front/v2/models/username/${nickname}/cam`
      );
      const data = await res.json();
      // console.log(data);

      const camData = Object.create(stripchatCamData);
      camData.name = data.user.user.name;
      camData.contestGender = data.user.user.contestGender;
      camData.broadcastGender = data.user.user.broadcastGender;
      camData.age = data.user.user.age;

      if (Object.keys(data.user.socialLinksData).length > 0) {
        for (const [key, value] of Object.entries(data.user.socialLinksData)) {
          camData[`${key}`] = clearDomain(value.link);
        }
      } else {
        // Jezeli nie ma zadnych social links to zwracam NULL
        console.log(`🛑 There is NO sociallinks (${nickname}) \n\n`);
        return null;
      }

      return camData;
    };

    const getLiveStripchat = async () => {
      // isRefreshingStripchat.value = true;
      liveStripchat.value = [];
      const res = await fetch(`https://go.xlviiirdr.com/api/models/online`);
      const data = await res.json();
      // console.log(data);
      liveStripchat.value = Object.values(data.models).map((el) => el.username);
      // console.log(liveStripchat.value);
    };

    const printLast200nicks = () => {
      let last200nicks = liveStripchat.value.slice(151, 200);
      last200nicks.forEach((el) => console.log(el));
    };

    const checkFirst500nicks = (startNum, numberOfNicks) => {
      console.log("checkFirst500nicks:", numberOfNicks);
      let firstNicks = liveStripchat.value.slice(startNum, numberOfNicks);
      console.log(firstNicks);
      updateData(firstNicks);
    };

    const updateData = (arr) => {
      arr.forEach(async (el) => {
        ////////////////
        // dla kazdego nicku, spradzam czy nick ma social links,

        await sleep(generateRandom(20) * 1000);
        let data = await getDataStripchat(el);
        // jesli ma, to sprawdzam czy mam go w bazie,
        if (data) {
          let number = await handleSearch("stripchat", el);
          // jesli nie ma go w bazie to go dodaje
          if (number == 0) {
            let basicData = { stripchat: el, status: "todo" };
            let elNew = { ...data, ...basicData };
            handleSubmitData(elNew);
          } else return;
        }
      });

      // }
      // });
    };

    const openPopup = () => (isPopup.value = true);
    const closePopup = () => (isPopup.value = false);

    const getCamNick = (camId) => {
      currentCamId.value = camId;
      console.log("🆔", currentCamId.value);

      console.log(cams.value);
      chosenCam.value = Object.values(
        JSON.parse(JSON.stringify(cams.value))
      ).filter((el) => el.id == camId);

      console.log(
        Object.values(JSON.parse(JSON.stringify(cams.value))).filter(
          (el) => el.id == camId
        )
      );
      console.log(currentCamId.value);
      console.log(chosenCam.value);
      // console.log(
      //   `👩 Stripchat ${chosenCam.value[0].stripchat} (${chosenCam.value.length})`
      // );

      if (chosenCam.value) {
        let camNickname = chosenCam.value[0].stripchat;
        console.log(camNickname);
        console.log(chosenCam.value[0]);
        // return chosenCam.value[0].stripchat;
        return camNickname;
      }
    };

    const updateCamInfo = async (docId, newData, updateType) => {
      console.log(docId);
      const docRef = doc(db, databaseName.value, docId);
      await updateDoc(docRef, newData);
      console.log(`✅👧🏼 Profile ${docId} updated `);

      if (updateType === "refresh") {
        await refreshPopup(docId);
      }
    };

    // TODO zmienic w calosci zeby to sie robilo na czyms innym a nie na 'cams', moze 'camsTemp' pozniej bede mogl zzrobi bez filterow bo cams ciagle mam w pamieci, poza tym zrob watchEffect zeby camsTemp sie zmienialo jak cos dojdzie nowego bo bazy
    // TODO zmienc zeby bylo zapytanie do bazy

    const getLiveStripchatWithTwitter = async () => {
      await getLiveStripchat();
      isOnlyOnline.value = true;
    };

    const capitalize = (s) => {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    };

    const inputOnChange = (inputName) => {
      console.log(inputName);
    };

    const handleAddNewCamEl = () => {
      console.log(handleAddNewCamEl);
    };

    const camDone = async (camId, statusText) => {
      console.log(`cam status change to ${statusText}`);
      // changeCamStatus(statusText);
      let additionalCamData = { status: statusText };
      await updateCamInfo(camId, additionalCamData);
      clearCurrentId();
      resetChosenCamData();
    };

    const findAllUrls = (data) => {
      console.log(data);
      var urlRegex =
        // /([-A-Z0-9a-z+&@#\/%?=~_|!:,.;]*[\.][^\s][-A-Z0-9+&@#\/%=~_|][-A-Z0-9+&@#\/%=~_|]*)/gi;
        // /([-A-Z0-9a-z+&@#\/%?=~_|!:,.;]*[\.][^\s][-A-Z0-9+&@#\/%=~_|][-A-Z0-9+&@#\/%=~_!|]*)/gi;
        /([-A-Z0-9a-z+&@#\/%?=~_|!:,.;]*[\.][^\s][-A-Z0-9+&@#\/%=~_|][-A-Z0-9+&@#\/%~_!?=|]*)/gi;

      // D.C., Colombia

      let allFoundUrls = [];

      data.replace(urlRegex, function (url) {
        if (!url.includes("https://") && !url.includes("@")) {
          // console.log(`🔗 https://${url}`);
          allFoundUrls.push(`https://${url}`);
        } else {
          // console.log("🔗", url);
          allFoundUrls.push(`${url}`);
        }
      });
      // TODO przefiltrowac nazwa domeny [example .com .you .pl]  pomiedzy 2-5 znakow
      // TODO https://6.66
      // TODO https://pinkie.oficial
      console.log(data);
      console.log(allFoundUrls);
      return allFoundUrls;
    };
    // https://twitter.com/Miss_Floracam instagram w tekscie i inne // TODO /b/miss_flora/ Instagram flora_modelocolombiana, tiktok florajust
    // https://twitter.com/Pinpineskass adres bez www
    // https://twitter.com/an19sul   IG //TODO @an19sul Ig: An19sul Para contenido

    let instagramText = [
      "ig:",
      "ig : ",
      "instagram:",
      "Instagramg:",
      "insta:",
      "ig: ",
      "instagram: ",
      "insta: ",
      "ig ",
      "instagram ",
      "insta ",
      "Instagramg ",
    ];
    let tiktokText = ["tiktok ", "tiktok", "tiktok:", "tiktok: ", "tiktok :"];
    let onlyfansText = ["onlyfans ", "onlyfans :", "onlyfans : "];
    let camsodaText = ["camsoda ", "camsoda"];
    let chaturbateText = ["chaturbate ", "chaturbate"];
    let stripchatText = ["stripchat ", "stripchat"];
    let mynameText = [
      "name is",
      "name is ",
      "name is:",
      "i am ",
      "i'm ",
      "i’m ",
      "call me ",
      "mi nombre",
      "mi nombre ",
    ];

    const specialWords = [
      "@camsodagirls",
      "@chaturbate",
      "@stripchat",
      "@manyvids",
      "@stream",
      "#camsodagirls",
      "#chaturbate",
      "#stripchat",
      "#manyvids",
      "#stream",
      "y.o.",
      "stripchat.official",
      "/intent/tweet",
    ];

    const unpropperNames = [
      "a",
      "an",
      "not",
      "waiting",
      "from",
      "single",
      "follow",
      "aquarius",
      "pisces",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpio",
      "sagittarius",
      "capricorn",
    ];

    const findNextWord = (data, triggerText) => {
      console.log(data);

      let resultEnd;
      triggerText.forEach((el) => {
        // let result = data.match(new RegExp("[^a-z]" + el + "\(\\w+)"));
        // let result = data.match(new RegExp(el));
        // let result = data.match(new RegExp(el + "\s+([\w\.]+)"));
        // let result = data.match(new RegExp("\b" + el + "\s+([\w\.]+"));
        // let result = data.match(new RegExp(`\b${el}([\w\.]+)`));
        // let result = data.match(new RegExp(`/${el} [\w\.]+/gm`));
        // let result = data.match(new RegExp(el + "[\\w\\.]+", "gm"));
        let result = data.match(
          new RegExp("[^a-z]" + el + "\\s+([\\w\\.]+)", "gm")
        );

        if (
          result && // zamist tych 2 linijek ponizej mozna zrobic taki zapis
          // result != null &&
          // result != undefined &&
          isNaN(result[1]) &&
          !unpropperNames.includes(result[0])
        ) {
          result[0] = result[0].replace(el, "");

          // result = result.map((el) => el.trim());

          console.log("result NOT null");
          resultEnd = [el, result[0]];
          // console.log("🛢️", result);
          // console.log("🛢️", resultEnd);
        } else return;
      });

      console.log("other result");
      return resultEnd;
    };

    // 0: " tiktok lalala"
    // 1: "lalala"
    // groups: undefined
    // index: 3
    // input: "xxx tiktok lalala1 tiktok lala2.xxx"
    // length: 2

    // const testtext = "bio text tiktok: cami.candi lalalasta";
    // findNextWord(testtext, tiktokText);

    const removeSpecialWords = (wordsToRemoveArr, data) => {
      wordsToRemoveArr.forEach((word) => {
        data = data.replaceAll(word, "");
      });
      return data;
    };
    // const testtext = "@chaturbate chaturbate.com/nickname xxx.com";
    // removeSpecialWords(specialWords, testtext);

    const makeCamServiceUrl = (clearData, isServiceName, url) => {
      // if (isServiceName == "follow") return;
      if (isServiceName && !isServiceName.includes("follow")) {
        console.log(isServiceName);

        clearData = clearData
          .replace(
            `${isServiceName[0]}${isServiceName[1]}`,
            `${url}${isServiceName[1]}`
          )
          .replace(
            `${isServiceName[0]} ${isServiceName[1]}`,
            `${url}${isServiceName[1]}`
          );
      }
      return clearData;
    };

    const clearTwitterBioHtml = (data) => {
      console.log(data);
      let clearData = data
        .replace(/(<([^>]+)>)/gi, "\n")
        // .replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, "") // NOTE usuwanie emojis
        .replace(/[^\p{L}\p{N}\p{P}\{=}\p{Z}^$\n]/gu, "") // NOTE usuwanie emojis
        .replace(/[\n\r]/g, " ")
        .replace(/\s\s+/g, " ")
        .toLowerCase(); // NOTE ta zmiana ulatwia wiele pozniej ale powoduje ze linki z bitly i YT nie dzialaja

      console.log(clearData);
      clearData = removeSpecialWords(specialWords, clearData);
      console.log(clearData);

      clearData = clearData
        .replaceAll("http://\n", "https://")
        .replaceAll("https://\n", "https://")
        .replaceAll("/b/", "/")
        .replaceAll("/p/", "/")
        .replaceAll("&amp;", "&")
        .replaceAll("translate bio", "")
        .replaceAll("accounts/login", "")
        .replaceAll("....", "")
        .replaceAll("...", "")
        .replaceAll("..", "")
        .replaceAll(":", ": ")
        .replaceAll(/(?<!https)\:/g, " ") //  zrobic wyszukanie regex jelsi jest https
        .replaceAll("@", "");

      console.log(clearData);

      if (clearData.includes("joined")) {
        clearData = clearData.substring(0, clearData.indexOf("joined"));
      }
      if (clearData.includes("born")) {
        clearData = clearData.substring(0, clearData.indexOf("born"));
      }
      if (clearData.includes("followed by")) {
        clearData = clearData.substring(0, clearData.indexOf("followed by"));
      }

      console.log(clearData);
      clearData = clearData
        // .substring(0, clearData.indexOf("Joined"))
        .replace("following", "")
        .replace("follow", "")
        .replace("/follow", "")
        .replaceAll("\r\n", "")
        .trim();

      // findNextWord(clearData, instagramText);
      console.log(clearData);
      return clearData;
    };

    const findKeywordAndMakeUrlsInBio = (clearData) => {
      let isInstagram = findNextWord(clearData, instagramText);
      console.log("💡", clearData);
      let isTiktok = findNextWord(clearData, tiktokText);
      console.log("💡", isTiktok);
      let isOnlyfans = findNextWord(clearData, onlyfansText);
      let isCamsoda = findNextWord(clearData, camsodaText);
      let isChaturbate = findNextWord(clearData, chaturbateText);
      let isStripchat = findNextWord(clearData, stripchatText);

      clearData = makeCamServiceUrl(
        clearData,
        isInstagram,
        "https://www.instagram.com/"
      );
      console.log("💡", clearData);
      clearData = makeCamServiceUrl(
        clearData,
        isTiktok,
        "https://www.tiktok.com/@"
      );
      console.log("💡", clearData);
      clearData = makeCamServiceUrl(
        clearData,
        isOnlyfans,
        "https://onlyfans.com/"
      );
      clearData = makeCamServiceUrl(
        clearData,
        isCamsoda,
        "https://www.camsoda.com/"
      );
      clearData = makeCamServiceUrl(
        clearData,
        isChaturbate,
        "https://chaturbate.com/"
      );
      clearData = makeCamServiceUrl(
        clearData,
        isStripchat,
        "https://stripchat.com/"
      );

      console.log("_________________________");
      console.log(clearData);
      return clearData;
    };

    const clearName2 = (name) => {
      let newName = name
        .replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, "")
        .replace(/[0-9]/gu, "")
        .replace("@", "");
      // console.log("\n");
      // console.log(name);
      // console.log(newName);

      return newName;
    };

    const findNameinBio = (clearData) => {
      let isMyname = findNextWord(clearData, mynameText);
      console.log(clearData);
      // console.log(mynameText);

      if (isMyname) {
        // TODO clearName
        // console.log(clearData);
        // if (isMyname[1] !== "a") {
        if (!unpropperNames.includes(isMyname[1])) {
          console.log(isMyname);
          isMyname[1] = clearName2(isMyname[1]);
          isMyname[1] = capitalize(isMyname[1]);
          console.log("👩 NAME:", isMyname[1]);

          const nameObject = new AdditionalUrlSplitted("name", isMyname[1]);
          // whereToAdd.push(nameObject);
          console.log(nameObject);
          return nameObject;
          // const additionalUrlSplittedItem = new AdditionalUrlSplitted(
          //   "name",
          //   isMyname[1]
          // );
          // additionalSplittedUrls.value.push(additionalUrlSplittedItem);
        }
      }
    };

    const returnFlattenObject = (arr) => {
      const flatObject = {};
      for (let i = 0; i < arr.length; i++) {
        for (const property in arr[i]) {
          flatObject[`${property}`] = arr[i][property];
          // flatObject[`${property}_${i}`] = arr[i][property];
        }
      }
      return flatObject;
    };

    const removedNullValueFromObj = (objectName) => {
      if (Object.keys(objectName).length > 0) {
        for (const [key, value] of Object.entries(objectName)) {
          if (value === null) {
            delete objectName[`${key}`];
          }
        }
      } else {
        console.log(`🛑 There is NO differences between old/new data \n\n`);
      }
      return objectName;
    };

    const removeKeyFromObj = (objectName, keyName) => {
      // console.log("❤️");
      // console.log(objectName);
      // console.log(objectName[keyName]);
      if (objectName[keyName]) {
        delete objectName[`${keyName}`];
        console.log(`${keyName} REMOVED`);
      } else return;
      // console.log(objectName);
    };

    const pasteHtmlBio = () => {
      navigator.clipboard
        .readText()
        .then((text) => {
          let clearBio = clearTwitterBioHtml(text); // czysci text bio
          console.log(clearBio);
          let dataWithUrls = findKeywordAndMakeUrlsInBio(clearBio); // znajduje elementy w bio i zamienia na https://
          console.log(dataWithUrls);
          let arrUrls = findAllUrls(dataWithUrls); // return array with urls
          console.log(arrUrls);
          let uniqueUrls = addAdditionalUnique(arrUrls); // bierze arraya z urlami i sprawdza czy sie nie powtarzaja, zwraca Arra z Obiektami uikalne bez powtorzen
          let nameFound = findNameinBio(clearBio); // znajduje imie i zwraca obiekt { name: name } do dditionalSplittedUrls.value

          ///////////////////////////
          let newCamInfo;

          if (nameFound) {
            newCamInfo = [...uniqueUrls, nameFound];
          } else {
            newCamInfo = [...uniqueUrls];
          }
          // console.log(newCamInfo);

          // porownaj nowy obiekt z pobranym z firebasa i dorzuc tylko to co innne
          let additionalCamData = diff(
            chosenCamData.value,
            returnFlattenObject(newCamInfo)
          );

          additionalCamData = removedNullValueFromObj(additionalCamData);
          removeKeyFromObj(additionalCamData, "stripchat");

          // NOTE sprawdz kazdy additionalCamData i jesli keyName ma tylko 1 znak to go usun
          Object.keys(additionalCamData).forEach((key) => {
            // console.log(key, additionalCamData[key]);
            if (key.length < 2) {
              console.log("⛔ KEY za krótki — usuwamy");
              removeKeyFromObj(additionalCamData, key);
            }
          });

          console.log("INFO DIFF");
          console.log(additionalCamData);
          console.log("🆔", currentCamId.value);

          // TODO odswiez Popup z pokazanymi nowymi danymi
          // TODO na podstawie ilosci serwisow i sociali (pól w ogole) wstawi inny opis (>7 mozna dawac info ze zarabia na rozne zposoby itd, jesli miej to ten ubogi opis albo jakis inny)
          if (additionalCamData) {
            updateCamInfo(currentCamId.value, additionalCamData, "refresh");
          }
          additionalSplittedUrls.value = [];
          newCamInfo = [];
        })
        // .then((data) => {
        //   console.log(data);
        //   // clearTwitterBioHtml(text);
        // })
        .catch((err) => {
          console.error(
            "Failed to read clipboard contents (OR other err) : ",
            err
          );
        });
    };

    const refreshPopup = async (currentCamId) => {
      await getDataStripchat(getCamNick(currentCamId));
      console.log(chosenCam.value[0]);
      getChosenCamData(chosenCam.value[0]);
      openPopup();
    };

    const getChosenCamData = (chosenCamCam) => {
      console.log(chosenCamCam);
      // console.log(chosenCamCam[0]);
      chosenCamData.value = chosenCamCam;
      // console.log(chosenCamData.value);
      // console.log(chosenCamData.value.name);
    };
    const resetChosenCamData = () => {
      chosenCamData.value = null;
      console.log(chosenCamData.value);
    };

    const parseDate = (timestamp) => {
      console.log(parse(timestamp, "t", new Date()));
      return formatDistanceToNow(parse(timestamp, "t", new Date()));
    };

    const howManyKeys = (objName) => {
      // let number = Object.keys(objName).length;
      // if (number <= 7) {
      //   return "🧸";
      // } else if (number > 7 && number < 14) return "🔥";
      // if (number >= 14) return "🔥🔥🔥";

      let number = 0;
      Object.keys(objName).forEach((key) => {
        if (objName[key] !== null) number++;
      });
      if (number <= 10) {
        isCamgirlPro.value = false;
        return "🧸";
      } else if (number > 10 && number < 14) {
        isCamgirlPro.value = true;
        return "🔥";
      }
      if (number >= 14) {
        isCamgirlPro.value = true;
        return "🔥🔥🔥";
      }
    };

    const handleClickLogout = () => {
      signOut(auth);
    };
    const handleClickChangeDatabase = () => {
      // databaseName.value = "camsTEMP";
      if (databaseName.value == "camsTEMP") {
        databaseName.value = "cams";

        // cams.value = getCollection(databaseName.value, "twitter")["documents"];
        // console.log(cams.value);
        // console.log(cams.value.length);

        // zrobic pobieranie wlasciwej bazy cams
      } else {
        databaseName.value = "camsTEMP";
        // { documents: cams } = getCollection(databaseName.value, "twitter");
        // cams.value = getCollection(databaseName.value, "twitter")["documents"];
        // console.log(cams.value);
        // console.log(cams.value.length);
      }
      console.log(`change2test ${databaseName.value}`);
    };

    const handleDoneToday = (typeOfHandle) => {
      if (typeOfHandle == "done") {
        if (
          localStorage.getItem("CS-doneToday") &&
          localStorage.getItem("CS-doneTodaySummary")
        ) {
          doneToday.value = localStorage.getItem("CS-doneToday");
          doneTodaySummary.value = localStorage.getItem("CS-doneTodaySummary");
          doneToday.value++;
          doneTodaySummary.value++;

          localStorage.setItem("CS-doneToday", doneToday.value);
          localStorage.setItem("CS-doneTodaySummary", doneTodaySummary.value);
        } else {
          doneToday.value = 1;
          doneTodaySummary.value = 1;
          localStorage.setItem("CS-doneToday", doneToday.value);
          localStorage.setItem("CS-doneTodaySummary", doneTodaySummary.value);
        }
      } else {
        if (localStorage.getItem("CS-doneTodaySummary")) {
          doneTodaySummary.value = localStorage.getItem("CS-doneTodaySummary");
          doneTodaySummary.value++;
          localStorage.setItem("CS-doneTodaySummary", doneTodaySummary.value);
        } else {
          doneTodaySummary.value = 1;
          localStorage.setItem("CS-doneTodaySummary", doneTodaySummary.value);
        }
      }
    };

    const handleResetDoneToday = () => {
      doneToday.value = 0;
      doneTodaySummary.value = 0;
      localStorage.setItem("CS-doneToday", doneToday.value);
      localStorage.setItem("CS-doneTodaySummary", doneTodaySummary.value);
    };

    const normalizeTwitterUrl = (twitterUrl) => {
      const searchTerm = "/status/";
      const indexOfFirst = twitterUrl.indexOf(searchTerm);

      let twitterNormalizedUrl = twitterUrl.substr(0, indexOfFirst);
      console.log(twitterNormalizedUrl);

      return twitterNormalizedUrl;
    };

    watchEffect(() => {
      if (!user.value) {
        router.push("/login");
      }

      if (databaseName.value == "camsTEMP") {
        console.log(databaseName.value);
        isTempDB.value = true;
      } else {
        console.log(databaseName.value);
        isTempDB.value = false;
      }
      // console.log(cams);
      // console.log(cams.value);
      // console.log(cams.value.length);
    });

    return {
      pasteFromClipboard,
      splittedUrls,
      additionalSplittedUrls,
      cams,
      handleSubmitData,
      search,
      handleSearch,
      getDataStripchat,
      getLiveStripchat,
      liveStripchat,
      printLast200nicks,
      // stopRefreshStripchatLive,
      // isRefreshingStripchat,
      openPopup,
      closePopup,
      isPopup,
      clickedId,
      chosenCam,
      chosenCamData,
      getChosenCamData,
      resetChosenCamData,
      getLiveStripchatWithTwitter,
      // getLiveStripchatTodo,
      formatDistanceToNow,
      inputOnChange,
      camDone,
      getCamNick,
      addNewCamEl,
      checkFirst500nicks,
      checkTo,
      checkFrom,
      isOnlyOnline,
      doneToday,
      doneTodaySummary,
      pasteHtmlBio,
      clearCurrentId,
      standardFields,
      newName,
      parseDate,
      handleClickLogout,
      user,
      handleClickChangeDatabase,
      howManyKeys,
      handleDoneToday,
      handleResetDoneToday,
      databaseName,
      isTempDB,
      isCamgirlPro,
      normalizeTwitterUrl,
    };
  },
};
</script>

<style>
.home {
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
  padding: 15px;
}

.addNew {
  height: 56px;
  width: 56px;
  border-radius: 150px;
  border: 0px;
  background-color: rgb(0, 60, 255);
  font-size: 2rem;
  line-height: 56px;
  color: rgb(255, 255, 255);
  position: fixed;
  bottom: 35px;
  left: 35px;
}

.addNew:hover {
  background-color: rgb(0, 49, 209);

  cursor: pointer;
  transition-duration: 0.5s;
}

#mainTextarea {
  width: 100%;
  height: 500px;
  border: 1px solid rgb(114, 114, 114);
  background-color: #202124;
  border-radius: 7px;
  padding: 15px;
  color: #ccc;
  box-sizing: border-box;
}

.search {
  width: 100%;
  height: 56px;
  border: 1px solid rgb(114, 114, 114);
  background-color: #202124;
  border-radius: 7px;
  padding: 15px;
  color: #ccc;
  box-sizing: border-box;
  margin-bottom: 35px;
}

.search-btn {
  padding: 10px 16px;
  border-radius: 4px;
  border: 0px;
  position: absolute;
  top: 26px;
  right: 35px;
  background-color: rgb(0, 49, 209);
  color: white;
}
.search-btn:hover {
  cursor: pointer;
}

.closeBtn {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 26px;
  right: 35px;
  z-index: 11;

  width: 39px;
  height: 39px;

  font-size: 1.5rem;
  line-height: 39px;
  color: white;
  border: 2px solid white;
  border-radius: 100px;
  background-color: #202124;
}
.closeBtn:hover {
  cursor: pointer;
  background-color: #3f3f3f;
  transition-duration: 0.3s;
}

.getData {
  border-radius: 4px;
  border: 0px;
  padding: 10px 16px;
  margin: 0px 10px 20px 0px;
  height: 46px;
  border: 1px solid rgb(114, 114, 114);
  background-color: #202124;
  color: white;
}

.getData:hover {
  cursor: pointer;
  background-color: #3f3f3f;
  transition-duration: 0.3s;
}

input.getData {
  padding: 0px 5px;
  width: 65px;
}

td,
th {
  padding: 5px 20px;
  text-align: left;
}

.popup {
  position: absolute;
  box-sizing: border-box;
  z-index: 10;
  width: 100%;

  background-color: #202124;

  padding: 55px 25px;
  padding-bottom: 150px;
}

.row {
  background-color: #1a1a1a;
  padding: 10px 25px;
  border-radius: 7px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;

  /* align-items: center; */
  /* gap: 10px 5px; */
}
.row:hover {
  cursor: pointer;
  background: rgba(0, 60, 255, 1);
  transition-duration: 0.2s;
}
.status {
  padding-right: 25px;
  width: 50px;
}
.online {
  padding-right: 5px;
  width: 25px;
}
.camservice {
  padding-right: 25px;
  width: 250px;
}
.id {
  padding-right: 25px;
  width: 250px;
  /* text-align: left; */
  color: rgb(128, 128, 128);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.7rem;
  /* padding-left: 10px; */
}

.camData {
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
}
.camservices {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: column wrap;
  padding: 15px;

  padding: 25px;
  box-sizing: border-box;
}
.details {
  padding: 25px;
}
.socials {
  padding: 25px;
}

.entry {
  width: 100%;
}
.entry label {
  display: block;
  color: rgb(128, 128, 128);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.7rem;
  padding-left: 10px;
}
.entry label a {
  color: rgb(128, 128, 128);
  text-decoration: none;
}
.entry label a:hover {
  color: rgb(255, 255, 255);
  transition-duration: 0.3s;
}

.entry input {
  width: 100%;
  margin-bottom: 15px;
  border-radius: 7px;
  padding: 10px 10px;
  font-size: 1.2rem;
}

.additional.entry input {
  width: 100%;
  margin-bottom: 15px;
  border-radius: 0px 7px 7px 0px;
  border-left: 2px solid grey;
  padding: 10px 10px;
  /* font-size: 1.2rem; */
  font-size: 0.9rem;
}
.small input {
  font-size: 0.7rem;
  letter-spacing: 2px;
  padding-top: 0px;
  width: 100%;
}

.entry input {
  margin-bottom: 15px;
  background-color: transparent;
  background-color: rgb(48, 48, 48);
  color: white;

  border: 0px solid grey;
  border-radius: 7px;
}

.entry input:hover {
  background-color: rgb(56, 56, 56);
  transition-duration: 0.3s;
}
.entry input:disabled {
  margin-bottom: 15px;
  background-color: transparent;
  background-color: rgb(48, 48, 48);
  color: white;
  border: 0px solid grey;
  border-radius: 7px;
  cursor: no-drop;
}
.small input:disabled {
  background-color: transparent;
  color: rgb(128, 128, 128);
}

.statusContainer {
  display: flex;
  position: fixed;
  top: 26px;
  left: 50px;
  height: 39px;
  z-index: 11;
  /* overflow: auto; */
  /* background-color: pink; */
}

.camStatusBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  padding: 0px 10px;
  height: 39px;
  font-size: 1.2rem;
  line-height: 39px;
  color: white;

  border-radius: 7px;
  border: 2px solid #15c60c;
  background-color: #15c60c;
}
.camStatusBtn:hover {
  background-color: #11990a;
  border: 2px solid #11990a;
  cursor: pointer;
}

.greyBtn {
  background-color: #202124;
  border: 2px solid rgb(104, 104, 104);
  color: rgb(104, 104, 104);
}
.greyBtn:hover {
  background-color: #202124;
  border: 2px solid rgb(190, 190, 190);
  color: rgb(190, 190, 190);
  transition-duration: 0.4s;
}

.magic {
  background-color: #886ce4;
  border: 2px solid #886ce4;
  color: #000000;
}
.magic:hover {
  background-color: #fce100;
  border: 2px solid #fce100;
  color: #000000;
}
.hidden {
  display: none;
}
.logout {
  width: 100%;
  padding: 35px 0px;
  text-align: center;
}

.isTempDB {
  background-color: #101042;
}
</style>
